import React, { FC } from 'react'
import styles from './FormFieldLabel.module.scss'

interface Props {
  label: string
}
export const FormFieldLabel: FC<Props> = ({ label }) =>
  label ? <div className={styles.Label}>{label}</div> : null
